import { useEffect } from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { PaddiqLogo, PrivacyPolicyContent, PRIVACY_POLICY_EFFECTIVE_DATE } from '@kangaroo/ui';

export function PublicPrivacyPage() {
  useEffect(() => {
    const title = document.title;
    document.title = 'Privacy policy | Paddiq';
    return () => {
      document.title = title;
    };
  }, []);
  return (
    <Box sx={{ minHeight: '100dvh', bgcolor: '#f8f9fb', color: '#23242a' }}>
      <Container maxWidth="md">
        <Stack
          component="header"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ py: 3, borderBottom: '1px solid #e1e3e8' }}
        >
          <Box
            component="a"
            href="/"
            aria-label="Paddiq home"
            sx={{ display: 'inline-flex', textDecoration: 'none' }}
          >
            <PaddiqLogo variant="header" wordmarkColor="#1f2937" wordmarkSize="1.4rem" />
          </Box>
          <Button href="/login" size="small" sx={{ color: '#515361', textTransform: 'none' }}>
            Open Paddiq
          </Button>
        </Stack>
        <Box component="main" sx={{ py: { xs: 4, md: 7 } }}>
          <Typography
            variant="overline"
            sx={{ color: '#7c3aed', letterSpacing: '.13em', fontWeight: 700 }}
          >
            Your information
          </Typography>
          <Typography
            component="h1"
            sx={{ fontSize: { xs: 32, md: 44 }, fontWeight: 750, letterSpacing: '-.04em', mb: 2 }}
          >
            Privacy policy
          </Typography>
          <Typography sx={{ color: '#656775', mb: 1 }}>
            How Paddiq handles your information and the choices you have.
          </Typography>
          <Typography sx={{ fontSize: 13, color: '#656775', mb: 5 }}>
            Effective {PRIVACY_POLICY_EFFECTIVE_DATE}
          </Typography>
          <Box
            sx={{
              '& section': { mb: 4 },
              '& h2': {
                fontSize: 20,
                lineHeight: 1.4,
                fontWeight: 700,
                letterSpacing: '-.015em',
                mt: 0,
                mb: 2,
              },
              '& p, & li': { fontSize: 15, lineHeight: 1.85, color: '#4c4e5a' },
              '& li': { mb: 1 },
              '& a': { color: '#7c3aed', overflowWrap: 'anywhere' },
              '& ul': { pl: 3 },
            }}
          >
            <PrivacyPolicyContent />
          </Box>
        </Box>
        <Box
          component="footer"
          sx={{ py: 3, borderTop: '1px solid #e1e3e8', color: '#656775', fontSize: 13 }}
        >
          Paddiq LLC ·{' '}
          <a href="mailto:support@paddiq.app" style={{ color: 'inherit' }}>
            support@paddiq.app
          </a>
        </Box>
      </Container>
    </Box>
  );
}
